export const getRatingChangeMeta = (
  diff: number,
  period = 'period',
  affix = '',
): { diffText: string; diffCssClass: string } => {
  let details = {
    diffText: 'no change',
    diffCssClass: 'h-noRatingChange',
  }
  if (diff < 0) {
    details = {
      diffText: `${diff}${affix} this ${period}`,
      diffCssClass: 'h-negativeRatingChange',
    }
  } else if (diff > 0) {
    details = {
      diffText: `+${diff}${affix} this ${period}`,
      diffCssClass: 'h-positiveRatingChange',
    }
  }
  return details
}
